<div padding-top padding-bottom *ngIf="!routes">
  <p class="ion-text-small ion-text-center">{{ noActivitiesMessage }}</p>
</div>
<ion-card>
  <div *ngFor="let route of routes">
    <div class="border-bottom">
      <ion-grid>
        <div>
          <ion-row>
            <ion-col size="12">
              <strong>{{ route.routeName }}</strong>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="4">
              <p class="small-font">
                {{ 'RESULT_CREATE_LABEL_DISTANCE' | translate }}
              </p>
            </ion-col>
            <ion-col size="8" class="border-left">
              <p class="small-font">
                {{ 'TOTAL_ALTITUDE' | translate }}
              </p>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="4" class="margin-top">
              <span class="big-font">
                {{ route?.distance }} km
              </span>
            </ion-col>
            <ion-col size="8" class="margin-top border-left">
              <span class="big-font">
                {{ route?.altitude }}
              </span>
            </ion-col>
          </ion-row>
        </div>
      </ion-grid>
      <div class="map" [attr.id]="route.id">
      </div>
      <div class="card-footer">
        <div class="block-img" (click)="onRedirectTracker(route)">
          <ion-button size="small" fill="clear">
            <ion-icon name="map"></ion-icon>
            {{ 'USE_ROUTE' | translate }}
          </ion-button>
        </div>
        <div class="block-img" (click)="onRedirectGallery(route)">
          <ion-button size="small" fill="clear">
            <ion-icon name="images"></ion-icon>
            Fotos
          </ion-button>
        </div>
        <div class="block-img" (click)="onParticipantList()">
          <ion-button size="small" fill="clear">
            <ion-icon name="people"></ion-icon>
            {{ 'INVITE_FRIENDS' | translate }}
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-card>